import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "searchInput", "itemList", "hiddenInput", "selectedName"]
  static values = { items: Array }

  connect() {
    this.filteredItems = this.itemsValue
  }

  openModal(event) {
    event.preventDefault()
    this.modalTarget.showModal()
    this.searchInputTarget.value = ""
    this.filterItems()
    // 포커스를 검색 필드로
    setTimeout(() => this.searchInputTarget.focus(), 100)
  }

  closeModal() {
    this.modalTarget.close()
  }

  filterItems() {
    const query = this.searchInputTarget.value.toLowerCase().trim()

    if (query === "") {
      this.filteredItems = this.itemsValue
    } else {
      this.filteredItems = this.itemsValue.filter(item =>
        item.name.toLowerCase().includes(query) ||
        (item.category && item.category.toLowerCase().includes(query))
      )
    }

    this.renderItemList()
  }

  renderItemList() {
    const currentItemId = parseInt(this.hiddenInputTarget.value, 10)

    if (this.filteredItems.length === 0) {
      this.itemListTarget.innerHTML = `
        <div class="p-4 text-center text-gray-500">
          검색 결과가 없습니다.
        </div>
      `
      return
    }

    this.itemListTarget.innerHTML = this.filteredItems.map(item => `
      <button type="button"
              class="w-full text-left px-4 py-3 hover:bg-gray-100 transition-colors flex items-center justify-between ${item.id === currentItemId ? 'bg-primary/10' : ''}"
              data-action="click->item-search#selectItem"
              data-item-id="${item.id}"
              data-item-name="${item.name}"
              data-item-unit="${item.unit || ''}">
        <div>
          <span class="font-medium">${item.name}</span>
          <span class="text-sm text-gray-500 ml-2">(${item.category || '미분류'})</span>
          <span class="text-sm text-gray-400 ml-1">- ${item.unit || '단위없음'}</span>
        </div>
        ${item.id === currentItemId ? '<svg class="w-5 h-5 text-primary" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>' : ''}
      </button>
    `).join('')
  }

  selectItem(event) {
    const itemId = event.currentTarget.dataset.itemId
    const itemName = event.currentTarget.dataset.itemName

    // hidden input 업데이트
    this.hiddenInputTarget.value = itemId

    // 선택된 재료 이름 표시
    this.selectedNameTarget.textContent = itemName

    // 모달 닫기
    this.closeModal()

    // change 이벤트 발생
    this.hiddenInputTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }

  // ESC 키로 모달 닫기
  handleKeydown(event) {
    if (event.key === "Escape") {
      this.closeModal()
    }
  }

  // 모달 외부 클릭 시 닫기
  handleBackdropClick(event) {
    if (event.target === this.modalTarget) {
      this.closeModal()
    }
  }
}
